import { insightConstants, THOUGHTSPOT_CONFIG } from "../_constants";

export const sherbotGetAIInstructionsRequest = (worksheetId) => {
    return {
        type: insightConstants.SHERBOT_GET_AI_INSTRUCTION_REQUEST,
        payload: {
            data_source_identifier: worksheetId,
        },
    };
};
export const sherbotGetAIInstructionComplete = (payload) => {
    return {
        type: insightConstants.SHERBOT_GET_AI_INSTRUCTION_COMPLETED,
        payload,
    };
};

export const sherbotGetAIInstructionError = (payload) => {
    return {
        type: insightConstants.SHERBOT_GET_AI_INSTRUCTION_ERROR,
        payload,
    };
};

export const sherbotUpdateAIInstructionRequest = (payload) => {
    const { worksheetId, aiInstruction } = payload;

    return {
        type: insightConstants.SHERBOT_UPDATE_AI_INSTRUCTION_REQUEST,
        payload: {
            data_source_identifier: worksheetId,
            nl_instructions_info: [
                {
                    instructions: aiInstruction,
                    scope: "GLOBAL",
                },
            ],
        },
    };
};

export const sherbotUpdateAIInstructionComplete = (payload) => {
    return {
        type: insightConstants.SHERBOT_UPDATE_AI_INSTRUCTION_COMPLETED,
        payload,
    };
};

export const sherbotUpdateAIInstructionError = (payload) => {
    return {
        type: insightConstants.SHERBOT_UPDATE_AI_INSTRUCTION_ERROR,
        payload,
    };
};

export const insightGetLiveboardListRequest = () => {
    return {
        type: insightConstants.INSIGHT_GET_LIST_OF_LIVEBOARD_REQUEST,
        payload: {
            dependent_object_version: "V2",
            include_auto_created_objects: false,
            include_dependent_objects: false,
            dependent_objects_record_size: 50,
            include_details: false,
            include_headers: false,
            include_hidden_objects: false,
            include_incomplete_objects: false,
            include_visualization_headers: false,
            record_offset: 0,
            record_size: 20,
            include_stats: false,
            include_discoverable_objects: false,
            show_resolved_parameters: false,
            liveboard_response_version: "V2",
            include_only_published_objects: false,
        },
    };
};

export const insightLiveboardListComplete = (payload) => {
    return {
        type: insightConstants.INSIGHT_GET_LIST_OF_LIVEBOARD_COMPLETE,
        payload,
    };
};

export const insightsGetJobRoleAndCountListRequest = () => {
    return {
        type: insightConstants.INSIGHT_GET_LIST_OF_JOB_ROLES_AND_COUNT_REQUEST,
        payload: {
            metadata_identifier: "cec0b2d5-c8f1-4f9f-8dc0-ea99bfef2787", //Participant Count by Job Role Across Applications (Exclude "customer" role) comes fron saved answer thoughtspot
            record_offset: 0,
            record_size: 50,
        },
    };
};

export const insightsGetJobRoleAndCountListCompleted = (payload) => {
    return {
        type: insightConstants.INSIGHT_GET_LIST_OF_JOB_ROLES_AND_COUNT_COMPLETED,
        payload,
    };
};

export const insightsGetDealersSummaryRequest = () => {
    return {
        type: insightConstants.INSIGHT_GET_DEALERS_SUMMARY_REQUEST,
        payload: {
            metadata_identifier: "b4b20699-3179-4462-a2d3-5eb2bccaf596", //Dealers summary inlcuded (Total area, location and Total dealer counts)
            record_offset: 0,
            record_size: 50,
        },
    };
};

export const insightGetDealersSummaryCompleted = (payload) => {
    return {
        type: insightConstants.INSIGHT_GET_DEALERS_SUMMARY_COMPLETED,
        payload,
    };
};
